import React, { useCallback, useEffect, useRef } from "react";
import useCabinClass from "./useCabinClass.js";
import { Select } from "../Shell/index.js";
const CABIN_CLASS_EXPERIMENT_TAG = "flights_cat_cabin_class_label";
const FUNNEL_STAGE_MAP = {
    searchresults: 4,
    "searchresults-outbound": 4,
    "searchresults-inbound": 4,
    "fly-anywhere": 5,
    home: 6,
    "not-found": 7
};
export default function CabinClassSelect() {
    const { cabinClass, cabinClassOptions, setCabinClass, cabinClassTitle, showCabinClassLabel, isMeta, routeName, onTrackSBExperimentStage, onTrackSBExperimentCustomGoal } = useCabinClass();
    const handleOnChange = useCallback((name) => {
        setCabinClass(name);
    }, [setCabinClass]);
    useEffect(() => {
        onTrackSBExperimentStage({ name: CABIN_CLASS_EXPERIMENT_TAG, stage: 1 });
        onTrackSBExperimentStage({ name: CABIN_CLASS_EXPERIMENT_TAG, stage: isMeta ? 3 : 2 });
        if (routeName && FUNNEL_STAGE_MAP[routeName]) {
            onTrackSBExperimentStage({ name: CABIN_CLASS_EXPERIMENT_TAG, stage: FUNNEL_STAGE_MAP[routeName] });
        }
    }, [isMeta, routeName, onTrackSBExperimentStage]);
    const hasTrackedClickRef = useRef(false);
    const handleOnClick = useCallback(() => {
        if (hasTrackedClickRef.current)
            return;
        hasTrackedClickRef.current = true;
        onTrackSBExperimentCustomGoal({ name: CABIN_CLASS_EXPERIMENT_TAG, customGoal: 1 });
    }, [onTrackSBExperimentCustomGoal]);
    return (React.createElement(Select, { value: cabinClass, name: "sr_cabin_class", "data-ui-name": "cabin_class_input", "aria-label": cabinClassTitle, options: cabinClassOptions, label: showCabinClassLabel ? `${cabinClassTitle}:` : undefined, onChange: (e) => {
            handleOnChange(e.target.value);
        }, onClick: handleOnClick }));
}
